// Generated by GitHub Copilot - Oct-12-2026

import { Component, ElementRef, inject, input, output } from '@angular/core';

/**
 * Reusable checkbox-list dropdown for toolbar filters.
 * Nothing is checked initially, which the parent treats as "no filter" (all data shown).
 * "Select all" checks every option so the parent can send all values.
 */
@Component({
  standalone: true,
  selector: 'app-multi-select-dropdown',
  imports: [],
  templateUrl: './multi-select-dropdown.component.html',
  styleUrl: './multi-select-dropdown.component.css',
  host: {
    '(document:click)': 'onDocumentClick($event)',
    '(keydown.escape)': 'close()',
  },
})
export class MultiSelectDropdownComponent {
  private host = inject<ElementRef<HTMLElement>>(ElementRef);

  /** Id of the toggle button, so an external <label for> can target it. */
  readonly inputId = input.required<string>();
  readonly label = input<string>('');
  readonly allLabel = input<string>('All');
  readonly options = input<string[]>([]);
  readonly selected = input<string[]>([]);
  readonly selectedChange = output<string[]>();

  open = false;

  /** Text shown on the toggle button. */
  get summary(): string {
    const selected = this.selected();
    if (!selected.length || this.allSelected) return this.allLabel();
    return selected.length === 1 ? selected[0] : `${selected.length} selected`;
  }

  get allSelected(): boolean {
    const options = this.options();
    return options.length > 0 && options.every((o) => this.selected().includes(o));
  }

  toggle(): void {
    this.open = !this.open;
  }

  close(): void {
    this.open = false;
  }

  isSelected(option: string): boolean {
    return this.selected().includes(option);
  }

  /** Checks every option, or clears the selection when all are already checked. */
  toggleAll(): void {
    this.selectedChange.emit(this.allSelected ? [] : [...this.options()]);
  }

  /** Adds/removes an option, emitting values in option order for a stable payload. */
  toggleOption(option: string): void {
    const next = new Set(this.selected());
    if (!next.delete(option)) next.add(option);
    this.selectedChange.emit(this.options().filter((o) => next.has(o)));
  }

  onDocumentClick(event: Event): void {
    if (this.open && !this.host.nativeElement.contains(event.target as Node)) this.close();
  }
}
